import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import subcategorySchema from "../utils/subcategorySchema";

export default function ArtworkSearchFiltersModal({
  open,
  onClose,
  statuses = [],
  statusFilter = [],
  onStatusChange,
  selectedCategory = "",
  onCategoryChange,
  selectedSubcategories = {},
  onSubcategoryChange,
  minPrice = "",
  maxPrice = "",
  onMinPriceChange,
  onMaxPriceChange,
  onClearAll,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Search Filters</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ mt: 0.5 }}>
          <FormControl size="small" fullWidth>
            <InputLabel id="artwork-status-filter-modal-label">Artwork Status</InputLabel>
            <Select
              labelId="artwork-status-filter-modal-label"
              multiple
              value={statusFilter}
              onChange={(e) => onStatusChange?.(e.target.value)}
              input={<OutlinedInput label="Artwork Status" />}
              renderValue={(selected) => selected.length === 0 ? "All statuses" : selected.join(", ")}
            >
              {statuses.map((name) => (
                <MenuItem key={name} value={name}>{name}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            select
            size="small"
            label="Artwork Category"
            value={selectedCategory}
            onChange={(e) => onCategoryChange?.(e.target.value)}
            fullWidth
          >
            <MenuItem value="">All</MenuItem>
            {Object.keys(subcategorySchema).map((cat) => (
              <MenuItem key={cat} value={cat}>{cat}</MenuItem>
            ))}
          </TextField>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
            <TextField
              size="small"
              label="Min Price"
              type="number"
              value={minPrice}
              onChange={(e) => onMinPriceChange?.(e.target.value)}
              fullWidth
              inputProps={{ min: 0, step: "any" }}
            />
            <TextField
              size="small"
              label="Max Price"
              type="number"
              value={maxPrice}
              onChange={(e) => onMaxPriceChange?.(e.target.value)}
              fullWidth
              inputProps={{ min: 0, step: "any" }}
            />
          </Stack>

          {selectedCategory && subcategorySchema[selectedCategory] && (
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>Subcategories</Typography>
              <Stack spacing={1.5}>
                {Object.keys(subcategorySchema[selectedCategory]).map((sub) => (
                  <TextField
                    key={sub}
                    select
                    size="small"
                    label={sub}
                    value={selectedSubcategories[sub] || ""}
                    onChange={(e) => onSubcategoryChange?.(sub, e.target.value)}
                    fullWidth
                  >
                    <MenuItem value="">All</MenuItem>
                    {subcategorySchema[selectedCategory][sub].map((opt) => (
                      <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                    ))}
                  </TextField>
                ))}
              </Stack>
            </Box>
          )}

        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClearAll}>Clear All</Button>
        <Button onClick={onClose} variant="contained">Apply</Button>
      </DialogActions>
    </Dialog>
  );
}
